// Webpack public path before any other imports

  // Importing the DynamicImports component
  import DynamicImports from './components/DynamicImports';
  import Misc from './components/misc';
 
  import header from './components/header';
  

  import accordion from './components/accordion';

  import inlinevideos from './components/inlinevideos';
  
  import swiper from './components/swiper';

  // Defining a self-invoking anonymous function that initializes the App
  const App = (() => {
  
    // Defining a function that will be called when the DOM is ready
    const domReady = () => {
      initComponents();
    };
  
    
    const initComponents = () => {
       // Calling the DynamicImports function to import dynamic components
      DynamicImports();
      Misc();
      header();
      accordion();
      inlinevideos();
      swiper();
    };
  
    // Using jQuery to attach the domReady function to the document's ready event
    jQuery(document).ready(domReady);
  })();
  
  